import React, { useState } from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import ChatIcon from '@mui/icons-material/Chat';

import ChatOption from './chatOption';
import { theme } from '../theme';

export default function OfficeChatSpeedDialBtn() {
    const [open, setOpen] = useState(false);

    return (
        <Box sx={{ transform: 'translateZ(0px)', flexGrow: 1 }}>
            <SpeedDial
                ariaLabel="SpeedDial"
                sx={{ position: 'absolute', bottom: 16, right: 16}}
                icon={<ChatIcon />}
                onClick={() => setOpen(true)}
                FabProps={{ color: theme.action_btn }}
            />

            <ChatOption
                show={open}
                handleClose={() => setOpen(false)}
            />
        </Box>
    );
}